<template>
    <div v-click-outside="hidePicker">
        <label v-if="label"
               :for="id"
               class="form-label">{{ label }}</label>
        <div class="input-group color-picker flex">
            <div class="color-picker__wrapper">
                <chrome-picker v-if="picker === 'chrome'"
                               v-show="displayPicker"
                               :value="colors"
                               :disable-fields="true"
                               class="vc-right"
                               @input="updateFromPicker" />
                <sketch-picker v-if="picker === 'sketch'"
                               v-show="displayPicker"
                               :value="colors"
                               :disable-fields="true"
                               class="vc-right"
                               @input="updateFromPicker" />
            </div>
            <div class="color-picker__container">
                <div class="color-picker__color"
                     :style="colorBox()"
                     @click="showPicker"></div>
            </div>
            <input ref="input"
                   :id="id"
                   :name="name"
                   type="text"
                   v-bind="$attrs"
                   class="form-control color-input"
                   @focus="showPicker"
                   @input="updateFromInput($event.target.value)"
                   @change="hidePicker"
                   placeholder="Выберите цвет..."
            />
            <button class="color-picker__reset-button"
                    :disabled="colorDefault === colorValue"
                    :title="colorDefault === colorValue ? '' : 'Вернуть настройку по умолчанию'"
                    @click.stop.prevent="updateFromInput(colorDefault)">
                <IconReset />
            </button>
        </div>
    </div>
</template>

<script>
import { Chrome, Sketch } from 'vue-color';
import ClickOutside from 'vue-click-outside';
import IconReset from '../Icons/icon-reset.vue';

export default {
    name: 'ColorPickerTemplate',

    components: {
        'chrome-picker': Chrome,
        'sketch-picker': Sketch,
        IconReset
    },

    directives: {
        ClickOutside
    },

    inheritAttrs: false,

    props: {
        id: {
            type: String,
            default: () => ''
        },
        name: {
            type: String,
            default: () => ''
        },
        color: {
            type: String,
            default: () => '',
        },
        label: {
            type: String,
            default: () => '',
        },
        picker:{
            type: String,
            default: () => 'chrome',
            validator: value => {
                return ['chrome', 'sketch'].indexOf(value) !== -1
            }
        },
        colorDefault: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            colors: {
                hex: '#000000',
            },
            colorValue: '',
            displayPicker: false,
            defaultColor: '#FF0000'
        }
    },

    watch: {
        colorValue(val) {
            if(val) {
                this.updateColors(val);
                this.$emit('input', val);
            }
        }
    },

    mounted() {
        this.setColor(this.color || '#000000');
    },

    methods: {
        colorBox() {
            return `background-color: ${this.colorValue};`;
        },

        setColor(color) {
            this.updateColors(color);
            this.colorValue = color;
        },

        updateColors(color) {
            if (color.slice(0, 1) === '#') {
                // Если это 8-символьный HEX (#RRGGBBAA), извлекаем альфа-канал
                if (color.length === 9) {
                    const hex = color.slice(0, 7); // #RRGGBB
                    const alphaHex = color.slice(7, 9); // AA
                    const alpha = parseInt(alphaHex, 16) / 255; // конвертируем в 0-1
                    
                    // Конвертируем HEX в RGB
                    const r = parseInt(hex.slice(1, 3), 16);
                    const g = parseInt(hex.slice(3, 5), 16);
                    const b = parseInt(hex.slice(5, 7), 16);
                    
                    this.colors = {
                        hex: hex,
                        rgba: { r, g, b, a: alpha },
                        a: alpha,
                    };
                } else {
                    this.colors = {
                        hex: color
                    };
                }
            }
        },

        showPicker() {
            if (!this.displayPicker) {
                this.displayPicker = true;
            }
        },

        hidePicker() {
            if (this.displayPicker) {
                this.displayPicker = false;
            }
        },

        togglePicker() {
            this.displayPicker ? this.hidePicker() : this.showPicker();
        },

        updateFromInput(value) {
            // Проверяем HEX форматы (3, 4, 6 или 8 символов)
            if (/^#([0-9A-F]{3,4}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(value)) {
                this.colorValue = value;
            }
        },

        updateFromPicker(color) {
            this.colors = color;
            // Если есть альфа-канал и он не равен 1, используем 8-символьный HEX, иначе обычный hex
            if (color.rgba && color.rgba.a < 1) {
                const alpha = Math.round(color.rgba.a * 255).toString(16).padStart(2, '0');
                this.colorValue = color.hex + alpha;
            } else {
                this.colorValue = color.hex;
            }
        }
    }
}
</script>

<style lang="scss">
    @import "ColorPicker";
</style>
